module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
 dates.forEach(function(date, i) { 
__p+='\n	<button data-spy="'+
((__t=( date.dateId ))==null?'':__t)+
'" class="live-class__schedule-date-btn">\n		<span class="live-class__formatted-day live-class__formatted-day--desktop">'+
((__t=( date.formattedDay ))==null?'':__t)+
'</span>\n\n		<span class="live-class__formatted-day live-class__formatted-day--mobile">'+
((__t=( date.formattedDayMobile ))==null?'':__t)+
'</span>\n\n		<span class="live-class__date">'+
((__t=( date.formattedDate ))==null?'':__t)+
'</span>\n	</button>\n';
 }) 
__p+='\n';
}
return __p;
};
